﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailAktionMobil extends GuiDetailGeneric {

    constructor() {
        super("AktionMobil");
    }

    override attachEvents() {
        super.attachEvents();

        $("#btnAktionAddPosition").on("click", (e) => this.clickAktionAddPosition(e));

        //$("div.erz-list div.erz-list-element > div:not(:has(input))").on("click", (e) => this.clickDetailRow(e));
        $("#VmDetail_Menge").on("keyup", () => this.onChangeMenge());
    }

    clickAktionAddPosition(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAktionAddPosition");
        e.preventDefault();

        const url = $("#btnAktionAddPosition").data("url") as string;
        this.gotoUrl(url);
    }

    onChangeMenge() {
        this.log("onChangeMenge");
        const txtMenge = $("#VmDetail_Menge").val() as string;
        const txtFaktor = $("#VmDetail_UmrechnungsfaktorZuTonne").val() as string;

        if (txtMenge == undefined || txtFaktor == undefined) return;

        const menge = Number(txtMenge.replace(",", "."));
        const faktor = Number(txtFaktor.replace(",", "."));

        const mengeInTonnen = menge * faktor;
        this.log(mengeInTonnen + "=" + menge + "*" + faktor);
        $("#VmDetail_MengeTonne").val(mengeInTonnen.toString().replace(".", ","));
    }
}
